module.exports = __webpack_public_path__ + "static/media/eyeVN.69d66031.png";